
import naja from "naja";
import onDomReady from "@/global/js/onDomReady";

const loadFromAres = (el) => {
	const loadFromAresEl = el.getElementById("loadFromAres");
	const registrationNumberInputEl = el.getElementsByName("companyRegistrationNumber")[0];

	if (loadFromAresEl !== null) {
		loadFromAresEl.addEventListener("click", e => {
			e.preventDefault();
			naja.makeRequest("GET", e.target.getAttribute("href"), {
				registrationNumber: registrationNumberInputEl.value
			}).then((payload) => {
				const aresData = JSON.parse(payload.aresData);
				if (aresData && aresData.company) {
					const companyEl = document.getElementsByName("company")[0];
					const taxIdEl = document.getElementsByName("taxId")[0];
					const streetEl = document.getElementsByName("street")[0];
					const cityEl = document.getElementsByName("city")[0];
					const postCodeEl = document.getElementsByName("postCode")[0];

					companyEl.value = aresData.company;
					taxIdEl.value = aresData.taxId;
					streetEl.value = aresData.street;
					cityEl.value = aresData.city;
					postCodeEl.value = aresData.postCode;
				}
			});
		});
	}
}

onDomReady(() => loadFromAres(document));

